export default "__VITE_PUBLIC_ASSET__4610a55e__"